import request from '@/utils/request'
export const accountInfoApi = {
  // 修改/绑定用户信息
  saveuserinfo: (data) => {
    return request.post(`api/business/saveuserinfo`, data)
  },
  // 同步销售产品到订阅词
  addCustomerWordByproduct: (params) => {
    return request.get(`api/business/addCustomerWordByproduct`, { params: params })
  },
   // 检查组织代码是否正确
  checkOrganizationCode: (params) => {
    return request.get(`api/business/checkOrganizationCode`, { params: params })
  },
}
